import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { siteContent } from "../content/siteContent";
import logo from "../assets/squadrcm_logo.png"; // Change the filename/extension if yours is .svg or .jpg

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-shadow duration-300 ${
        scrolled ? "bg-white shadow-md" : "bg-white/95 backdrop-blur"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            {/* Replaced Logo Image */}
        <img 
          src={logo} 
          alt="SquadRCM Logo" 
          className="h-11 w-auto object-contain" 
        />
            <div className="leading-tight">
              <div className="text-[17px] font-extrabold tracking-tight text-[#1a3a6e]">
                {siteContent.brand.logoText}
              {/*  <span className="text-[#22b8db]">{siteContent.brand.logoAccent}</span>*/}
              </div>
              <br></br>
              <div className="text-[10px] text-slate-500 tracking-widest uppercase">
                Private(OPC) Ltd
              </div>
            </div>
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-9">
            {siteContent.nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `text-[15px] font-semibold tracking-wide transition-colors ${
                    isActive
                      ? "text-[#22b8db]"
                      : "text-[#1a3a6e] hover:text-[#22b8db]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Right */}
          <div className="flex items-center gap-4">
            <a
              href={siteContent.contact.phoneHref}
              className="hidden lg:flex items-center gap-2 text-[#1a3a6e] hover:text-[#22b8db] transition-colors text-sm font-semibold"
            >
              <Phone className="w-4 h-4" />
              {siteContent.contact.phone}
            </a>
            <button
              onClick={() => setOpen((v) => !v)}
              className="md:hidden text-[#1a3a6e]"
              aria-label="Toggle menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="md:hidden pb-6 border-t border-slate-100">
            <div className="flex flex-col gap-1 pt-4">
              {siteContent.nav.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `px-2 py-3 rounded-md text-[15px] font-semibold ${
                      isActive
                        ? "text-[#22b8db] bg-cyan-50"
                        : "text-[#1a3a6e] hover:bg-slate-50"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <a
                href={siteContent.contact.phoneHref}
                className="flex items-center gap-2 px-2 py-3 text-[#1a3a6e] font-semibold"
              >
                <Phone className="w-4 h-4" />
                {siteContent.contact.phone}
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
